import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=7e775ae0&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=7e775ae0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e775ae0",
  null
  
)

export default component.exports